import { render, staticRenderFns } from "./cookiePolicy.vue?vue&type=template&id=2b590d9e&scoped=true"
var script = {}
import style0 from "./cookiePolicy.vue?vue&type=style&index=0&id=2b590d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b590d9e",
  null
  
)

export default component.exports